<template>
  <div class="theme-picker">
    <div class="theme-grid">
      <div
        v-for="theme in availableThemes"
        :key="theme.gradientKey"
        class="theme-item"
        :class="{ selected: value.gradientKey === theme.gradientKey }"
        @click="selectTheme(theme)"
      >
        <div class="theme-swatch" :style="{ background: theme.gradient }">
          <div class="theme-accent" :style="{ backgroundColor: theme.accentHex }"></div>
        </div>
        <div class="theme-label">{{ theme.label }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ThemePicker",
  props: {
    value: {
      type: Object,
      default: () => ({ gradientKey: "purple", accentHex: "#7D5ABA" }),
    },
  },
  data() {
    return {
      availableThemes: [
        {
          gradientKey: "purple",
          accentHex: "#360065",
          gradient: "linear-gradient(210deg, #FAF5FF 0%, #B097D8 100%)",
          label: "Purple",
        },
        {
          gradientKey: "yellow",
          accentHex: "#6E5518",
          gradient: "linear-gradient(210deg, #FFFCDD 0%, #FDE456 100%)",
          label: "Yellow",
        },
        {
          gradientKey: "pink",
          accentHex: "#6E1861",
          gradient: "linear-gradient(210deg, #FFFAFF 0%, #FF9AE3 100%)",
          label: "Pink",
        },
        {
          gradientKey: "green",
          accentHex: "#00654B",
          gradient: "linear-gradient(210deg, #DDFFF6 0%, #68BCAC 100%)",
          label: "Green",
        },
        {
          gradientKey: "orange",
          accentHex: "#6E4018",
          gradient: "linear-gradient(210deg, #FFE9DD 0%, #FDB056 100%)",
          label: "Orange",
        },
      ],
    };
  },
  methods: {
    selectTheme(theme) {
      this.$emit("input", {
        gradientKey: theme.gradientKey,
        accentHex: theme.accentHex,
      });
    },
  },
};
</script>

<style scoped>
.theme-picker {
  margin-bottom: 0;
}

.theme-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 14px;
}

.theme-item {
  cursor: pointer;
  transition: all 0.2s ease;
}

.theme-item.selected .theme-swatch {
  box-shadow: 0 0 0 3px rgba(125, 90, 186, 0.3);
  transform: scale(1.08);
}

.theme-swatch {
  width: 100%;
  height: 72px;
  border-radius: 12px;
  position: relative;
  transition: all 0.25s ease;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.theme-swatch:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.theme-accent {
  position: absolute;
  bottom: 10px;
  right: 10px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 3px solid white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  transition: all 0.2s;
}

.theme-item.selected .theme-accent {
  transform: scale(1.15);
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.25);
}

.theme-label {
  text-align: center;
  font-size: 11px;
  font-weight: 600;
  margin-top: 8px;
  color: #6B7280;
  letter-spacing: 0.3px;
  text-transform: uppercase;
}

.theme-item.selected .theme-label {
  color: #7D5ABA;
  font-weight: 700;
}
</style>

